import { render, staticRenderFns } from "./EmailCampaign.vue?vue&type=template&id=41470b32&"
import script from "./EmailCampaign.vue?vue&type=script&lang=js&"
export * from "./EmailCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports